(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3299],{

/***/ 25531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CustomCarousel; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/custom-carousel/CustomCarousel.module.scss.js


var css_248z = ".CustomCarousel-module_main__4Xe9U {\n  position: relative;\n}\n\n.CustomCarousel-module_row__YVtIr {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  flex-direction: row;\n  overflow-x: scroll;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  overflow-y: scroll;\n  scroll-behavior: smooth;\n  -webkit-transition: all 3000ms ease-in-out;\n  -moz-transition: all 3000ms ease-in-out;\n  -ms-transition: all 3000ms ease-in-out;\n  -o-transition: all 3000ms ease-in-out;\n  transition: all 3000ms ease-in-out;\n}\n\n.CustomCarousel-module_row__YVtIr > div:nth-last-child(1) div {\n  margin-right: 0;\n}\n\n.CustomCarousel-module_next__9OTzF {\n  position: absolute;\n  top: 40%;\n  right: 0;\n  z-index: 5;\n  cursor: pointer;\n  overflow: hidden;\n  border: none;\n  outline: none;\n}\n.CustomCarousel-module_next__9OTzF svg {\n  position: absolute;\n  margin: auto;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 6px;\n  height: 16px;\n}\n\n.CustomCarousel-module_prev__DvC9i {\n  position: absolute;\n  top: 40%;\n  left: 0;\n  z-index: 5;\n  cursor: pointer;\n  overflow: hidden;\n  border: none;\n  outline: none;\n}\n.CustomCarousel-module_prev__DvC9i svg {\n  position: absolute;\n  margin: auto;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 6px;\n  height: 16px;\n}\n\n.CustomCarousel-module_next__9OTzF::before,\n.CustomCarousel-module_prev__DvC9i::before {\n  content: \"\";\n  position: absolute;\n  z-index: 2;\n  height: 100%;\n  width: 100%;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n}\n\n.CustomCarousel-module_row__YVtIr::-webkit-scrollbar {\n  display: none;\n}\n\n.CustomCarousel-module_prevNextWrapper__Q707t {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n}\n\n.CustomCarousel-module_dots__zKEeU {\n  max-width: max-content;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.CustomCarousel-module_dots__zKEeU .CustomCarousel-module_dot__sMsW4 {\n  background-color: #c4c4c4;\n  border-radius: 50%;\n  display: inline-block;\n  cursor: pointer;\n}\n.CustomCarousel-module_dots__zKEeU .CustomCarousel-module_dot__sMsW4.CustomCarousel-module_activeDot__HaSFV {\n  background-color: var(--primary-color);\n}\n\n@media (max-width: 991px) {\n  .CustomCarousel-module_dots__zKEeU {\n    margin: 0 auto 0;\n  }\n  .CustomCarousel-module_dots__zKEeU .CustomCarousel-module_dot__sMsW4 {\n    width: 9px;\n    height: 9px;\n    margin: 0 3px;\n  }\n}\n@media (min-width: 992px) {\n  .CustomCarousel-module_row__YVtIr {\n    align-items: center;\n  }\n  .CustomCarousel-module_dots__zKEeU {\n    margin: 30px auto 0;\n  }\n  .CustomCarousel-module_dots__zKEeU .CustomCarousel-module_dot__sMsW4 {\n    width: 12px;\n    height: 12px;\n    margin: 0 5px;\n  }\n}";
var Styles = {"main":"CustomCarousel-module_main__4Xe9U","row":"CustomCarousel-module_row__YVtIr","next":"CustomCarousel-module_next__9OTzF","prev":"CustomCarousel-module_prev__DvC9i","prevNextWrapper":"CustomCarousel-module_prevNextWrapper__Q707t","dots":"CustomCarousel-module_dots__zKEeU","dot":"CustomCarousel-module_dot__sMsW4","activeDot":"CustomCarousel-module_activeDot__HaSFV"};
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=CustomCarousel.module.scss.js.map

// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/hooks/useIntersect.js
var useIntersect = __webpack_require__(86369);
;// CONCATENATED MODULE: ../core/dist/components/custom-carousel/CustomCarousel.js





const CustomCarousel = ({ children, containerClass, rowClass, itemClass, activeClass, nextArrowClass, prvArrowClass, prevNextBtnsClass, scrollBy, items, fallback, prvArrow, nextArrow, length, dotsClass, activeDotClass }) => {
    const elmRef = (0,react.useRef)(null);
    const itemRef = (0,react.useRef)(null);
    const [scrollByitemWidth, setScrollByitemWidth] = (0,react.useState)(0);
    const [isLastItem, setIsLastItem] = (0,react.useState)(false);
    const [isFirstItem, setIsFirstItem] = (0,react.useState)(false);
    const [currentItem, setCurrentItem] = (0,react.useState)(0);
    const [isMouseOver, setIsMouseOver] = (0,react.useState)(false);
    (0,react.useEffect)(() => {
        if (scrollByitemWidth) {
            scrollHorizontal(scrollByitemWidth);
        }
    }, [scrollByitemWidth, currentItem]);
    const { entry: lastInterSectionObj, setNode: lastElmRef } = (0,useIntersect/* useIntersect */.U)({
        // rootMargin: getHeightByViewPort(0),
        threshold: 1
    });
    (0,react.useEffect)(() => {
        if ((lastInterSectionObj === null || lastInterSectionObj === void 0 ? void 0 : lastInterSectionObj.intersectionRatio) === 1) {
            setIsLastItem(true);
        }
        else {
            setIsLastItem(false);
        }
        return () => {
            setIsLastItem(false);
        };
    }, [lastInterSectionObj, length]);
    const { entry: firstInterSectionObj, setNode: firstElmRef } = (0,useIntersect/* useIntersect */.U)({
        // rootMargin: getHeightByViewPort(0),
        threshold: 1
    });
    (0,react.useEffect)(() => {
        if ((firstInterSectionObj === null || firstInterSectionObj === void 0 ? void 0 : firstInterSectionObj.intersectionRatio) === 1) {
            setIsFirstItem(true);
        }
        else {
            // if (items?.length === 1) {
            //     setIsLastItem (false)
            // }
            setIsFirstItem(false);
        }
        return () => {
            setIsFirstItem(false);
        };
    }, [firstInterSectionObj, length]);
    const scrollHorizontal = (scrollOffset) => {
        elmRef.current.scrollLeft += scrollOffset;
        setScrollByitemWidth(0);
    };
    const handlePrvArrow = (event) => {
        if (isFirstItem) {
            setScrollByitemWidth(itemRef.current.offsetWidth * length);
            setCurrentItem(length - 1);
        }
        else {
            setScrollByitemWidth(itemRef.current.offsetWidth * scrollBy * -1);
            setCurrentItem(currentItem - 1);
        }
        event.target.setAttribute("disabled", true);
        setTimeout(function () {
            event.target.removeAttribute("disabled");
        }, 800);
    };
    const handleNextArrow = (event) => {
        if (isLastItem) {
            setScrollByitemWidth(itemRef.current.offsetWidth * length * -1);
            setCurrentItem(0);
        }
        else {
            setScrollByitemWidth(itemRef.current.offsetWidth * scrollBy);
            setCurrentItem(currentItem + 1);
        }
        event.target.setAttribute("disabled", true);
        setTimeout(function () {
            event.target.removeAttribute("disabled");
        }, 800);
    };
    const prevCountRef = (0,react.useRef)();
    (0,react.useEffect)(() => {
        prevCountRef.current = currentItem;
    }, [currentItem]);
    const prevCount = prevCountRef.current;
    (0,react.useEffect)(() => {
        if (itemRef.current)
            if (currentItem > prevCount) {
                setScrollByitemWidth(itemRef.current.offsetWidth * (currentItem - prevCount));
            }
            else {
                setScrollByitemWidth(itemRef.current.offsetWidth * (prevCount - currentItem) * -1);
            }
    }, [currentItem, itemRef]);
    const onClickDotHandleItems = (targetItem) => {
        setCurrentItem(targetItem);
    };
    (0,react.useEffect)(() => {
        let interval;
        if (!isMouseOver) {
            interval = setInterval(() => {
                if (currentItem < length - 1) {
                    setCurrentItem((count) => count + 1);
                }
                else {
                    setCurrentItem((count) => count - (length - 1));
                }
            }, 5000);
        }
        else {
            clearInterval(interval);
        }
        return () => {
            clearInterval(interval);
        };
    }, [currentItem, isMouseOver]);
    const onMouseEnterStopInterval = () => {
        setIsMouseOver(true);
    };
    const onMouseLeaveStartInterval = () => {
        setIsMouseOver(false);
    };
    return (react.createElement("div", { className: classnames_default()(Styles.main, containerClass) },
        ((items === null || items === void 0 ? void 0 : items.length) || children) && (react.createElement(react.Fragment, null,
            react.createElement("div", { ref: elmRef, className: classnames_default()(Styles.row, rowClass) }, items === null || items === void 0 ? void 0 :
                items.map((item, index) => (react.createElement("div", { key: index, ref: index === 0 ? firstElmRef : index === items.length - 1 ? lastElmRef : itemRef, className: classnames_default()(Styles.item, itemClass, currentItem === index && activeClass), onMouseEnter: onMouseEnterStopInterval, onMouseLeave: onMouseLeaveStartInterval }, item))),
                children),
            prvArrow && items && items.length > 1 ? (react.createElement("button", { className: classnames_default()(Styles.prev, prvArrowClass), onClick: (e) => handlePrvArrow(e) }, prvArrow)) : (react.createElement(react.Fragment, null)),
            nextArrow && items && items.length > 1 ? (react.createElement("button", { className: classnames_default()(Styles.next, nextArrowClass), onClick: (e) => handleNextArrow(e) }, nextArrow)) : (react.createElement(react.Fragment, null)),
            items && items.length > 1 ? (react.createElement("div", { className: classnames_default()(Styles.dots, dotsClass) }, items === null || items === void 0 ? void 0 : items.map((data, index) => (react.createElement("span", { key: index, className: classnames_default()(Styles.dot, currentItem === index && Styles.activeDot, currentItem === index && activeDotClass), onClick: () => onClickDotHandleItems(index) }))))) : (react.createElement(react.Fragment, null)))),
        fallback));
};


//# sourceMappingURL=CustomCarousel.js.map


/***/ }),

/***/ 56976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Intro_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15667);
/* harmony import */ var _Intro_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Intro_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14304);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3__);





var Intro = function(param) {
    var text = param.text;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_Intro_module_scss__WEBPACK_IMPORTED_MODULE_4___default().main),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Intro_module_scss__WEBPACK_IMPORTED_MODULE_4___default().conainer), "container"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Intro_module_scss__WEBPACK_IMPORTED_MODULE_4___default().intro),
                dangerouslySetInnerHTML: {
                    __html: (0,isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3__.sanitize)(text)
                }
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Intro);


/***/ }),

/***/ 60085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ our_customer_says_OurCustomerSays; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/service-pages/common/our-customer-says/OurCustomerSays.module.scss
var OurCustomerSays_module = __webpack_require__(61690);
var OurCustomerSays_module_default = /*#__PURE__*/__webpack_require__.n(OurCustomerSays_module);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ../core/dist/components/custom-carousel/CustomCarousel.js + 1 modules
var CustomCarousel = __webpack_require__(25531);
// EXTERNAL MODULE: ./components/service-pages/common/testimonial-card/TestimonialCard.module.scss
var TestimonialCard_module = __webpack_require__(49525);
var TestimonialCard_module_default = /*#__PURE__*/__webpack_require__.n(TestimonialCard_module);
// EXTERNAL MODULE: ./components/utils/AppImg.tsx
var AppImg = __webpack_require__(17073);
;// CONCATENATED MODULE: ../core/dist/icons/quotation_marks_blue.svg
var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgQuotationMarksBlue(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 43 43"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#quotation_marks_blue_svg__clip0)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#1053FF",
    d: "M8.857 18.042c.525-3.297 4.647-6.82 7.87-6.895.224 0 .45-.075.6-.225.15-.075.299-.15.374-.374 1.124-2.099.525-3.748-1.35-5.097-2.173-1.574-5.62 0-7.344 1.424C4.66 10.473.238 16.693.463 22.614c-.75 3.972-.6 8.244.525 11.767.75 2.248 2.923 3.372 5.171 3.522 2.249.15 6.895.825 8.919-.524 2.023-1.35 2.173-3.973 2.398-6.22.225-2.474.9-7.121-1.199-9.07-2.099-1.873-8.094.15-7.42-4.047zm24.733 0c.524-3.297 4.646-6.82 7.87-6.895a.85.85 0 00.599-.225c.15-.075.3-.15.375-.374 1.124-2.099.524-3.748-1.35-5.097-2.173-1.574-5.62 0-7.344 1.424-4.347 3.598-8.77 9.818-8.544 15.739-.75 3.972-.6 8.244.524 11.767.75 2.248 2.923 3.372 5.172 3.522 2.248.15 6.895.825 8.918-.524 2.024-1.35 2.174-3.973 2.399-6.22.225-2.474.9-7.121-1.2-9.07-2.098-1.873-8.169.15-7.42-4.047z"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "quotation_marks_blue_svg__clip0"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h43v43H0z"
  })))));
}

/* harmony default export */ var quotation_marks_blue = (SvgQuotationMarksBlue);
;// CONCATENATED MODULE: ./components/service-pages/common/testimonial-card/TestimonialCard.tsx







var TestimonialCard = function(param) {
    var data = param.data, width = param.width;
    var isMobile = (0,react.useContext)(app_context/* AppContext */.Il).isMobile;
    var cardStagePaddinglr = 296;
    var cardMarginlr = 16;
    var cardWidth = width - (cardStagePaddinglr + cardMarginlr);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (TestimonialCard_module_default()).customerSaysRow,
        style: {
            width: "".concat(isMobile ? width : cardWidth, "px")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((TestimonialCard_module_default()).imgBox),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                    src: data.image,
                    alt: data.name,
                    layout: "responsive",
                    width: "538",
                    height: "517"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((TestimonialCard_module_default()).textCol),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(quotation_marks_blue, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: data.massage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                        children: [
                            data.name,
                            data.location && ", " + data.location
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                        children: data.company
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var testimonial_card_TestimonialCard = (TestimonialCard);

// EXTERNAL MODULE: ../core/dist/icons/arrow-right-white.svg
var arrow_right_white = __webpack_require__(89905);
;// CONCATENATED MODULE: ./components/service-pages/common/our-customer-says/OurCustomerSays.tsx







//Icons

var OurCustomerSays = function(param) {
    var customerSaysData = param.customerSaysData, sectionTitle = param.sectionTitle, sectionText = param.sectionText;
    var isMobile = (0,react.useContext)(app_context/* AppContext */.Il).isMobile;
    var carouselWrapperElmRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(0), testimonialCardWidth = ref[0], setTestimonialCardWidth = ref[1];
    (0,react.useEffect)(function() {
        setTestimonialCardWidth(carouselWrapperElmRef.current.offsetWidth);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classnames_default()((OurCustomerSays_module_default()).main, (OurCustomerSays_module_default()).customersSaysSection),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((OurCustomerSays_module_default()).conainer, "container"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (OurCustomerSays_module_default()).heading,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: sectionTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: sectionText
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: carouselWrapperElmRef,
                    className: (OurCustomerSays_module_default()).carouselWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCarousel/* default */.Z, {
                        nextArrowClass: (OurCustomerSays_module_default()).nextBtn,
                        prvArrowClass: (OurCustomerSays_module_default()).prevBtn,
                        containerClass: (OurCustomerSays_module_default()).carouselContainer,
                        rowClass: (OurCustomerSays_module_default()).carouselRow,
                        itemClass: (OurCustomerSays_module_default()).carouselItem,
                        activeClass: (OurCustomerSays_module_default()).carouselActive,
                        prevNextBtnsClass: (OurCustomerSays_module_default()).buttonsClass,
                        length: customerSaysData === null || customerSaysData === void 0 ? void 0 : customerSaysData.length,
                        scrollBy: 1,
                        prvArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right_white/* default */.Z, {}),
                        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right_white/* default */.Z, {}),
                        items: customerSaysData === null || customerSaysData === void 0 ? void 0 : customerSaysData.map(function(data, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(testimonial_card_TestimonialCard, {
                                data: data,
                                width: testimonialCardWidth
                            }, index);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var our_customer_says_OurCustomerSays = (OurCustomerSays);


/***/ }),

/***/ 51847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ getFullTruckBookingPageLayout; }
/* harmony export */ });
/* unused harmony export getFullTruckBookingStaticProps */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _vahak_core_dist_services_faq_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99891);
/* harmony import */ var components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62307);




var getFullTruckBookingPageLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_2__/* .useDefaultTopLayout */ .E;
var getFullTruckBookingStaticProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var faqs;
        return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _vahak_core_dist_services_faq_service__WEBPACK_IMPORTED_MODULE_1__/* .FaqService.getFaqsByCateg */ .P.getFaqsByCateg({
                        categSlug: "booking-loads"
                    });
                case 2:
                    faqs = _ctx.sent.faqs;
                    return _ctx.abrupt("return", {
                        faqs: faqs
                    });
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getFullTruckBookingStaticProps() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 99610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _FullLoadBooking_module_scss__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(11939);
/* harmony import */ var _FullLoadBooking_module_scss__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_FullLoadBooking_module_scss__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _service_data_ServiceData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65962);
/* harmony import */ var _vahak_core_dist_services_user_analytics_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8880);
/* harmony import */ var _common_features_Features__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91299);
/* harmony import */ var _common_achievements_Achievements__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16609);
/* harmony import */ var _common_hero_section_HeroSection__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46523);
/* harmony import */ var _common_how_it_works_HowItWorks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42326);
/* harmony import */ var _common_faq_Faq__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71729);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42386);
/* harmony import */ var _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69406);
/* harmony import */ var _vahak_core_dist_constants_misc__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(77370);
/* harmony import */ var _vahak_core_dist_constants_Pages__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(52489);
/* harmony import */ var _vahak_core_dist_constants_routeStrings__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(12098);
/* harmony import */ var _common_intro_Intro__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(56976);
/* harmony import */ var _common_our_customer_says_OurCustomerSays__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(60085);
/* harmony import */ var _common_page_meta_tags_PageMetaTags__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(96696);
/* harmony import */ var _constants_breadcrumbs_constants__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(96080);
/* harmony import */ var _common_service_information_ServiceInformation__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(35778);




















var metaData = {
    title: "Find Truck Load Booking - India's Largest Online Transport Marketplace",
    description: "Make the most of your truck's space by booking a full truck load on Vahak's online load booking marketplace and double your revenue. Get a free quote today!",
    keywords: "full truck loading, full truck load, full load, full truck load services, full load transport services, full truck load charges, full truck load logistics india, full truck load company, full truck load companies in india, full truck load logistics, full truck load transport",
    canonicalUrl: "https://www.vahak.in/full-truck-load",
    schemaOrgJsonUrl: "/full-truck-load",
    ogImgSrc: "https://d3ib4ot6oar1ep.cloudfront.net/1920/75/webp/driver_checking_truck_loads.png",
    ogImgAltText: "Book Full Truck Load",
    breadcrumbList: (0,_constants_breadcrumbs_constants__WEBPACK_IMPORTED_MODULE_18__/* .breadcrumbsConstants */ .U)({}).fullTruckLoad
};
var FullLoadBooking = function(param) {
    var faqs = param.faqs;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)("servicePages").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_page_meta_tags_PageMetaTags__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                title: metaData.title,
                description: metaData.description,
                keywords: metaData.keywords,
                canonicalUrl: metaData.canonicalUrl,
                ogUrl: metaData.canonicalUrl,
                ogImgSrc: metaData.ogImgSrc,
                ogImgAltText: metaData.ogImgAltText,
                schemaOrgJsonUrl: metaData.schemaOrgJsonUrl,
                breadcrumbList: metaData.breadcrumbList
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: (_FullLoadBooking_module_scss__WEBPACK_IMPORTED_MODULE_19___default().main),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_hero_section_HeroSection__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        bannerTitle: t("servicePages:full-load-booking.hero-section.bannerTitle"),
                        bannerText: t("servicePages:full-load-booking.hero-section.bannerText"),
                        hrefURL: "".concat(_vahak_core_dist_constants_routeStrings__WEBPACK_IMPORTED_MODULE_13__/* .ROUTES.marketplace.getUrl */ .Z.marketplace.getUrl("load"), "?").concat(_vahak_core_dist_constants_misc__WEBPACK_IMPORTED_MODULE_11__/* .SOURCE_UTM */ .vq, "=").concat(_vahak_core_dist_constants_Pages__WEBPACK_IMPORTED_MODULE_12__/* .PageTypes.FULL_TRUCK_LOAD */ .c.FULL_TRUCK_LOAD),
                        hrefLabel: t("servicePages:full-load-booking.hero-section.hrefLabel"),
                        onLinkClick: function() {
                            (0,_vahak_core_dist_services_user_analytics_service__WEBPACK_IMPORTED_MODULE_3__/* .ga4sendEvent */ .zs)(_vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_10__/* .GA4EventNames.Servicepage_full_truck_load */ .wQ.Servicepage_full_truck_load, {
                                value: _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_10__/* .GA4ServicePageFullTruckLoadEventValues.book_full_truck_load */ .bc.book_full_truck_load
                            });
                        },
                        srcURL: "driver_checking_truck_loads.png",
                        altText: "driver checking truck loads",
                        sectionClass: (_FullLoadBooking_module_scss__WEBPACK_IMPORTED_MODULE_19___default().herroSection)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_achievements_Achievements__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        achievementData: (0,_service_data_ServiceData__WEBPACK_IMPORTED_MODULE_2__/* .useFtlAchievement */ .g)(),
                        sectionTitle: t("servicePages:online-load-booking.achievements.sectionTitle")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_intro_Intro__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        text: t("servicePages:full-load-booking.intro.text")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_service_information_ServiceInformation__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        heading: t("servicePages:full-load-booking.best-trucks-suited-for-full-truck-load.heading"),
                        sectionTitle: "",
                        sectionText: t("servicePages:full-load-booking.best-trucks-suited-for-full-truck-load.description")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_service_information_ServiceInformation__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        heading: t("servicePages:full-load-booking.transport-services-included-in-full-truck-load.heading"),
                        sectionTitle: "",
                        sectionText: t("servicePages:full-load-booking.transport-services-included-in-full-truck-load.description")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_service_information_ServiceInformation__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        heading: t("servicePages:full-load-booking.full-truck-load-service-providers-in-india.heading"),
                        sectionTitle: "",
                        sectionText: t("servicePages:full-load-booking.full-truck-load-service-providers-in-india.description")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_features_Features__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        features: (0,_service_data_ServiceData__WEBPACK_IMPORTED_MODULE_2__/* .useFullLoadFeatures */ .Lx)(),
                        sectionTitle: t("servicePages:full-load-booking.features.sectionTitle"),
                        ctaLink: "".concat(_vahak_core_dist_constants_routeStrings__WEBPACK_IMPORTED_MODULE_13__/* .ROUTES.marketplace.getUrl */ .Z.marketplace.getUrl("load")),
                        ctaLabel: t("servicePages:full-load-booking.features.ctaLabel"),
                        onCtaClick: function() {
                            (0,_vahak_core_dist_services_user_analytics_service__WEBPACK_IMPORTED_MODULE_3__/* .ga4sendEvent */ .zs)(_vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_10__/* .GA4EventNames.Servicepage_full_truck_load */ .wQ.Servicepage_full_truck_load, {
                                value: _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_10__/* .GA4ServicePageFullTruckLoadEventValues.explore_ftl_market */ .bc.explore_ftl_market
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_how_it_works_HowItWorks__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        howitwork: (0,_service_data_ServiceData__WEBPACK_IMPORTED_MODULE_2__/* .useOlbHowItworkData */ .BO)(),
                        sectionTitle: t("servicePages:full-load-booking.how-it-works.section-title"),
                        sectionText: t("servicePages:full-load-booking.how-it-works.section-text"),
                        tabAppNav: t("servicePages:online-load-booking.HowItWorks.tabAppNav"),
                        tabWebNav: t("servicePages:online-load-booking.HowItWorks.tabWebNav"),
                        onAppTabChange: function() {
                            (0,_vahak_core_dist_services_user_analytics_service__WEBPACK_IMPORTED_MODULE_3__/* .ga4sendEvent */ .zs)(_vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_10__/* .GA4EventNames.Servicepage_full_truck_load */ .wQ.Servicepage_full_truck_load, {
                                value: _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_10__/* .GA4ServicePageFullTruckLoadEventValues.mobile_app */ .bc.mobile_app
                            });
                        },
                        onWebTabChange: function() {
                            (0,_vahak_core_dist_services_user_analytics_service__WEBPACK_IMPORTED_MODULE_3__/* .ga4sendEvent */ .zs)(_vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_10__/* .GA4EventNames.Servicepage_full_truck_load */ .wQ.Servicepage_full_truck_load, {
                                value: _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_10__/* .GA4ServicePageFullTruckLoadEventValues.web */ .bc.web
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_faq_Faq__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        faqs: faqs,
                        sectionTitle: t("servicePages:full-load-booking.Faq.sectionTitle"),
                        sectionText: t("servicePages:full-load-booking.Faq.sectionText")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_our_customer_says_OurCustomerSays__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        customerSaysData: (0,_service_data_ServiceData__WEBPACK_IMPORTED_MODULE_2__/* .useCustomerSaysData */ .aN)(),
                        sectionTitle: t("servicePages:logistics-services.ourCustomerSays.sectionTitle"),
                        sectionText: t("servicePages:logistics-services.ourCustomerSays.sectionText")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FullLoadBooking);


/***/ }),

/***/ 15667:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"Intro_main__aXKeI","intro":"Intro_intro__RgmX1"};

/***/ }),

/***/ 61690:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"OurCustomerSays_main__OlKjq","heading":"OurCustomerSays_heading__felez","customerSaysRow":"OurCustomerSays_customerSaysRow__yJ8_E","textCol":"OurCustomerSays_textCol__BKuVd","imgBox":"OurCustomerSays_imgBox__2tI8d","customersSaysSection":"OurCustomerSays_customersSaysSection__rgXu4","buttonsClass":"OurCustomerSays_buttonsClass__N6NrN","prevBtn":"OurCustomerSays_prevBtn__O3v0X","nextBtn":"OurCustomerSays_nextBtn__fCp78","carouselRow":"OurCustomerSays_carouselRow__WVZeH","carouselItem":"OurCustomerSays_carouselItem__2rluV","carouselActive":"OurCustomerSays_carouselActive__1Y_sq"};

/***/ }),

/***/ 49525:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customerSaysRow":"TestimonialCard_customerSaysRow__R36_Q","textCol":"TestimonialCard_textCol__I0ljy","imgBox":"TestimonialCard_imgBox__b9OK6"};

/***/ }),

/***/ 11939:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"FullLoadBooking_main__0yl59","herroSection":"FullLoadBooking_herroSection__Aj0bj","ctaBanner":"FullLoadBooking_ctaBanner__ZfEBT","ctarow":"FullLoadBooking_ctarow__0Hu_k","textBox":"FullLoadBooking_textBox__iPu5M","intro":"FullLoadBooking_intro__Q1_vs","ctaBtn":"FullLoadBooking_ctaBtn__970xd","imgBox":"FullLoadBooking_imgBox__xY7q7","imageWrap":"FullLoadBooking_imageWrap__7AOHA","ctaBg":"FullLoadBooking_ctaBg__qS_zr"};

/***/ })

}]);